import { render } from "./firestore.vue?vue&type=template&id=d8763c24&ts=true"
import script from "./firestore.vue?vue&type=script&lang=ts"
export * from "./firestore.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__